import React from 'react';
import { Type } from 'lucide-react';

const TextSection = ({ section, className = '', ...props }) => {
  const { config, data } = section;

  const content = data?.content || config.content || '';

  return (
    <div className={`p-6 ${className}`} {...props}>
      {config.title && (
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
          {config.title}
        </h3>
      )}
      
      {content ? (
        <div
          className="prose dark:prose-invert max-w-none text-gray-700 dark:text-gray-300"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      ) : (
        <div className="flex flex-col items-center justify-center py-8 text-gray-500 dark:text-gray-400">
          <Type className="w-12 h-12 mb-2" />
          <p>No content</p>
        </div>
      )}
    </div>
  );
};

export default TextSection;

